import React, { useState } from "react";
import {
  FiArrowRight,
  FiCalendar,
  FiCheckCircle,
  FiMapPin,
  FiNavigation,
  FiShoppingCart,
  FiUsers,
} from "react-icons/fi";
import heroScreen from "../../assets/mobileScreenshots/Homescreen.jpg";
import routeScreen from "../../assets/mobileScreenshots/todaysVisitMap.jpg";
import "./sfaHero.css";
import SfaBookingModal from "./sfaBookingModal";

const SfaHero = ({ onBookDemo }) => {
  const [showSfaDemo, setShowSfaDemo] = useState(false);
  const handleBookDemo = () => {
    if (typeof onBookDemo === "function") {
      onBookDemo();
    }
  };

  return (
    <>
      <section className="sfa-hero-section">
        <div className="sfa-hero-bg-grid"></div>
        <div className="sfa-hero-bg-glow sfa-hero-bg-glow-one"></div>
        <div className="sfa-hero-bg-glow sfa-hero-bg-glow-two"></div>

        <div className="container">
          <div className="row align-items-center sfa-hero-row">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="sfa-hero-content">
                <div className="sfa-hero-eyebrow">
                  <span className="sfa-hero-eyebrow-dot"></span>
                  SALES FORCE AUTOMATION
                </div>

                <h1 className="sfa-hero-title">
                  Empower Your Sales Team
                  <br />
                  to Sell Smarter
                  <br />
                  <span>in the Field</span>
                </h1>

                <p className="sfa-hero-description">
                  TechCognics Sales Force Automation connects attendance, beat
                  planning, outlet visits, field activity, order capture and
                  sales visibility through one connected platform. Give your
                  sales team the tools to plan their day, execute visits
                  efficiently and keep management connected to field
                  performance.
                </p>

                <div className="sfa-hero-actions">
                  <button
                    type="button"
                    className="sfa-hero-primary-btn"
                    onClick={() => setShowSfaDemo(true)}
                  >
                    Book a Free SFA Demo
                    <span>
                      <FiArrowRight />
                    </span>
                  </button>

                  <a
                    href="#sfa-mobile-experience"
                    className="sfa-hero-secondary-btn"
                  >
                    Explore SFA
                    <span>
                      <FiArrowRight />
                    </span>
                  </a>
                </div>

                <div className="sfa-hero-capabilities">
                  <div className="sfa-hero-capability">
                    <span className="sfa-hero-capability-icon sfa-icon-teal">
                      <FiCalendar />
                    </span>
                    <span>Attendance</span>
                  </div>

                  <div className="sfa-hero-capability">
                    <span className="sfa-hero-capability-icon sfa-icon-orange">
                      <FiNavigation />
                    </span>
                    <span>Beat Planning</span>
                  </div>

                  <div className="sfa-hero-capability">
                    <span className="sfa-hero-capability-icon sfa-icon-cyan">
                      <FiMapPin />
                    </span>
                    <span>Outlet Visits</span>
                  </div>

                  <div className="sfa-hero-capability">
                    <span className="sfa-hero-capability-icon sfa-icon-purple">
                      <FiShoppingCart />
                    </span>
                    <span>Order Capture</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="sfa-hero-visual">
                <div className="sfa-hero-orbit sfa-hero-orbit-one"></div>
                <div className="sfa-hero-orbit sfa-hero-orbit-two"></div>
                <div className="sfa-hero-orbit sfa-hero-orbit-three"></div>

                <div className="sfa-hero-route">
                  <svg
                    viewBox="0 0 520 520"
                    role="img"
                    aria-label="Animated sales field route"
                  >
                    <path
                      className="sfa-route-path-bg"
                      d="M95 390 C130 310 125 235 195 200 C255 170 298 230 340 180 C382 130 420 160 440 105"
                    />

                    <path
                      className="sfa-route-path"
                      d="M95 390 C130 310 125 235 195 200 C255 170 298 230 340 180 C382 130 420 160 440 105"
                    />

                    <circle className="sfa-route-node" cx="95" cy="390" r="7" />

                    <circle
                      className="sfa-route-node"
                      cx="125"
                      cy="282"
                      r="7"
                    />

                    <circle
                      className="sfa-route-node"
                      cx="195"
                      cy="200"
                      r="7"
                    />

                    <circle
                      className="sfa-route-node"
                      cx="340"
                      cy="180"
                      r="7"
                    />

                    <circle
                      className="sfa-route-node"
                      cx="440"
                      cy="105"
                      r="7"
                    />

                    <circle className="sfa-route-marker" r="9">
                      <animateMotion
                        dur="7s"
                        repeatCount="indefinite"
                        rotate="auto"
                        path="M95 390 C130 310 125 235 195 200 C255 170 298 230 340 180 C382 130 420 160 440 105"
                      />
                    </circle>
                  </svg>
                </div>

                <div className="sfa-hero-device-shadow"></div>

                <div className="sfa-hero-phone">
                  <div className="sfa-hero-phone-speaker"></div>

                  <div className="sfa-hero-phone-screen">
                    <img
                      src={heroScreen}
                      alt="TechCognics SFA mobile dashboard"
                    />
                  </div>
                </div>

                <div className="sfa-hero-live-pill">
                  <span></span>
                  LIVE FIELD ACTIVITY
                </div>

                <div className="sfa-hero-stat-card sfa-stat-visits">
                  <div className="sfa-stat-icon sfa-stat-icon-orange">
                    <FiMapPin />
                  </div>

                  <div>
                    <strong>12</strong>
                    <span>Today's Visits</span>
                  </div>
                </div>

                <div className="sfa-hero-stat-card sfa-stat-orders">
                  <div className="sfa-stat-icon sfa-stat-icon-green">
                    <FiShoppingCart />
                  </div>

                  <div>
                    <strong>08</strong>
                    <span>Orders Captured</span>
                  </div>
                </div>

                <div className="sfa-hero-stat-card sfa-stat-outlets">
                  <div className="sfa-stat-icon sfa-stat-icon-purple">
                    <FiUsers />
                  </div>

                  <div>
                    <strong>24</strong>
                    <span>Outlets Covered</span>
                  </div>
                </div>

                <div className="sfa-hero-route-card">
                  <div className="sfa-route-card-header">
                    <div>
                      <span>Today's Route</span>
                      <strong>Field Coverage</strong>
                    </div>

                    <span className="sfa-route-status">Active</span>
                  </div>

                  <div className="sfa-route-card-image">
                    <img
                      src={routeScreen}
                      alt="TechCognics SFA today's route"
                    />
                  </div>
                </div>

                <div className="sfa-hero-check-card">
                  <span>
                    <FiCheckCircle />
                  </span>

                  <div>
                    <strong>Visit Completed</strong>
                    <small>Retail outlet checked in</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SfaBookingModal
        show={showSfaDemo}
        onClose={() => setShowSfaDemo(false)}
      />
    </>
  );
};

export default SfaHero;
